import { Commit } from 'vuex';
import { Toast } from 'vant';
import * as Types from '@/store/modules/task/types';
import { ITaskState } from '@/store/modules/task/interface';
import * as API from '@/store/modules/task/api';

const state = {
  fileListData: {},
  state: {},
  fromFileList: true,
};

const mutations = {
  setState(state: any, data: any) {
    state.state = data;
    localStorage.state = JSON.stringify(state.state);
  },

  setFileListData(state: any, data: any) {
    state.fileListData = data;
    //持久化存储
    localStorage.fileListData = JSON.stringify(state.fileListData);
  },
  setFromFileList(state: any, data: any) {
    state.fromFileList = data;
  },
};

export default { namespaced: true, state, mutations };
